import { create } from "zustand";
import {
  Promocion,
  getAllPromociones,
} from "../firebase/firestore/promociones";

type PromocionStore = {
  allPromociones: Promocion[];
  isLoading: boolean;
  fetchAllPromociones: () => Promise<void>;
  resetPromociones: () => void;
};

export const usePromocionStore = create<PromocionStore>((set, get) => ({
  allPromociones: [],
  isLoading: false,

  fetchAllPromociones: async () => {
    set({ isLoading: true });
    try {
      const promociones = await getAllPromociones();
      set({
        allPromociones: promociones,
        isLoading: false,
      });
    } catch (error) {
      console.error("Error fetching promociones:", error);
      set({ isLoading: false });
    }
  },

  resetPromociones: () => {
    set({
      allPromociones: [],
      isLoading: false,
    });
  },
}));
